// extracted by mini-css-extract-plugin
export default {"page-wrapper":"_404Page_page-wrapper__8wod5","main":"_404Page_main__8bDJ1","main-wrapper":"_404Page_main-wrapper__OfvyF","text":"_404Page_text__k+lXz","link":"_404Page_link__Vw2lU"};